import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initI18n } from './services/translation/i18n';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';

async function bootstrap() {
  await initI18n();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StrictMode>
  );
}

bootstrap();
